/**
 * Created by yangxy on 2022/11/24.
 * 播放器初始化时的缺省选项
 */
export default {
  // 应用ID，必填
  appId: '',
  // 第三方用户ID，必填
  accountId: '',
  // token鉴权，必填
  token: '',
  // 播放类型，必填。可填参数：live:直播，vod:点播
  type: '',
  // 播放器挂载点 (播放器容器)，必填
  videoNode: 'videoNode',
  // 多语言，选填。可填值：en | zh 。 默认：en
  language: 'en',
  // 是否自动播放，选填。默认:true。受浏览器限制，设置了该项也不一定能自动播放成功
  autoplay: true,
  // 自动播放失败是否设置静音再次尝试，此功能开启后在autoplay=true情况下生效
  autoplayMuteAttempt: false,
  // 是否默认静音，可基于此实施自动播放策略
  muted: false,
  // 封面地址，选填。 仅支持.jpg
  poster: '',

  // 主题，选填。可填值：classic | light 。 默认：classic
  theme: 'classic',

  // 直播相关参数, type==live时为必填。
  liveOption: null,
  // liveOption: {
  //   type: 'auto', // 直播播放类型   auto | hls | flv | rtmp | rtc | rtl
  //   roomId: '', // 直播房间ID, 必填
  //   defaultDefinition: '480p', // 非必填，默认480p， 支持same|720p|480p|360p
  //   swf: '', // 非必填，swf文件地址
  //   forceMSE: false, // 是否强制开启mse
  //   useSWF: undefined, // 非必填，是否使用flash
  //   autodegrade: true, // 是否开启rtl自动降级， 默认true。开启后在不支持rtl的情况下，会自动降级到flv或者hls播放
  //   useImmediateStream: true, // 用于延时直播中，强制使用实时流观看
  // },

  // 点播相关参数, type==vod时为必填。
  vodOption: null,
  // vodOption: {
  //   recordId: '', // 回放 ID
  //   defaultDefinition: '480p', // 非必填，默认480p， 支持same|720p|480p|360p
  //   swf: '', // 非必填，swf文件地址
  //   forceMSE: false, // 非必填，是否强制开启mse
  //   useSWF: undefined // 非必填，是否使用flash
  // },

  // video播放器样式
  videoStyleOption: {
    objectFit: '' // 填充模式，参考https://developer.mozilla.org/zh-CN/docs/Web/CSS/object-fit
    // contain: 保持视频尺寸比例的同时填充容器，直至视频窗口的一边与视窗边框对齐，但是四周可能出现黑边
    // cover: 保持视频尺寸比例的同时填满容器，但是部分内容可能被剪切。
    // fill: 拉伸视频以填满容器，但是不保证视频尺寸比例不变
  },

  // 延播场景下，是否强制忽略延迟，观看普通延迟直播流
  forceIgnoreDelay: false,

  // 本app_id是否使用自定义播放线路
  // 详见http://wiki.vhallops.com/pages/viewpage.action?pageId=371267213
  appCustomLine: false,

  // 跑马灯参数，选填
  marqueeOption: {
    enable: false, // 是否启用, 默认false
    displayType: 0, // 展示方式：0滚动 1闪动 默认0
    text: '', // 跑马灯的文字, 必填
    alpha: 100, // 透明度，默认100. 100完全显示 0隐藏
    size: 18, // 文字大小
    unit: 'px',
    h5FontSize: 16,
    h5Unit: 'px',
    color: '#ff8d41', // 文字颜色
    interval: 20, // 下次跑马灯开始与本次开始的时间间隔，秒为单位，默认20
    speed: 6000, // 跑马灯移动速度 3000快 6000中 10000慢（滚动时传入，闪动时不需要）
    position: 1 // 跑马灯位置 1:随机 2:上 3:中 4:下 ，默认1
  },

  // 水印参数，选填
  watermarkOption: {
    enable: false, // 是否启用, 默认false
    mode: 'image', // 模式：image-图片水英；text-文本水印
    url: '', // 水印图片的路径
    align: 'tr', // 水印图片的对其方式， tl | tr | bl | br 分别对应：左上，右上，左下，右下
    position: ['20px', '20px'], // 对应的横纵位置，支持px,vh,vw,%
    size: ['80px', '35px'], // 水印大小，支持px,vh,vw,%
    alpha: 100, // 水印透明度 100完全显示  0隐藏
    textConfig: {
      content: '', // 文本内容
      size: '16px', // 文字大小
      color: '#fff', // 文字颜色
      opacity: 30, // 不透明度，0-100，默认30
      multiline: false, // 是否多行，默认单行
      degrees: 0 // 旋转度数，默认不旋转
    }
  },

  // 追播参数，选填
  pursueOption: {
    // 追播
    enable: false, // 是否启用, 默认false
    mode: 'pursue', // 追播模式: pursue：追播，seek：跳转。默认 pursue
    hls: {
      bufferMax: 15, // 开启追播延时，默认15s
      remain: 5, // 结束追播剩余延时，默认5s
      pursueSpeed: 1.2 // 追播倍速，默认1.2倍速，pursue 模式下生效
    },
    flv: {
      bufferMax: 10, // 开启追播延时，默认10s
      remain: 2, // 结束追播剩余延时，默认2s
      pursueSpeed: 1.2 // 追播倍速，默认1.2倍速，pursue 模式下生效
    }
  },

  // 强制卡顿切线，配置
  thornOption: {
    enable: true, // 是否开启，默认 true
    changeType: 'cdn' // cdn: 切换cdn（默认），resolution: 切换清晰度
  },

  // 调度配置,选填
  schedulerOption: null,
  // schedulerOption: {
  // 强制清晰度列表，慎用。选填。如果有传入强制清晰度列表，则清晰度列表以传入列表为准；
  // quality: ['same', '720p', '480p', '360p', 'a']
  // },

  // 日志上报配置,选填（内部使用）
  reportOption: {
    enable: true,
    interval: 30 // 心跳，默认30s
  },

  // 自定义日志上报字段,选填（内部使用）
  otherOption: null,
  // otherOption: {
  //   biz_role: '',
  //   biz_id: '',
  //   biz_des01: '',
  //   biz_des02: ''
  // },

  // 点播字幕参数，选填
  vodSubtitleOption: {
    enable: false, // 是否启用, 默认false
    auto: true, // 是否自动开启字幕
    style: {} // 自定义样式
  },

  // 直播字幕参数，选填
  liveSubtitleOption: {
    enable: true, // 是否启用, 默认true
    auto: true // 在播放器初始化成功后，是否默认开启直播字幕
  },

  // 弹幕设置，选填
  barrageSetting: {
    enable: true, // 是否启用, 默认true
    useLocalCache: true, // 是否使用本地缓存配置
    localCacheKey: 'vhall_player_barrageSetting', //缓存key
    positionRange: [0, 0.25], // 全屏现实化从上之 [startPostion: number, endPosition: number] 百分比，区域显示
    speed: 10000,
    popupContainer: null, //dom节点(#id或者.class), 存放弹幕设置面板的容器，可选，优先级高于默认容器
    popupBlock: false, // 初始化 popupContainer 是否block方式展示（自定义面板的容器时生效）
    // 弹幕设置面板样式
    popupStyle: {
      isLight: false, // 浅色背景
      themeColor: 'orange' // 主题色
    },
    // 弹幕本身样式
    style: {
      fontSize: 16, //[12,16,20]
      unit: 'px',
      h5FontSize: 16, //[12,16,20] 2024-12-31Wap端调整到和pc一样
      h5Unit: 'px',
      fontFamily: 'Microsoft Yahei',
      color: '#ffffff',
      border: 'none',
      textShadow: null, // 默认值： 1px 1px 0px #ffffff 参考：https://www.w3school.com.cn/cssref/pr_text-shadow.asp
      borderWidth: 0, // 单位 px
      padding: 0, // 左右内边距
      opacity: 100, // 弹幕透明度
      backgroundColor: 'none' // 背景色
    }
  },
  // 视频打点配置
  markPointsOption: {
    showAiHightlight: false,
    customTitleSeparator: '|',
    fontSize: '12px',
    fontFamily: '',
    color: '#ffffff',
    backgroundColor: '#000000CC'
  }
};
